import { Flex } from '@chakra-ui/react';

import { UserTabIcon } from '~/features/enterprise/landing-pages/icons';

type GenericPersonAvatarProps = {
  iconSize?: string;
  variant?: 'dark' | 'light';
};

export function GenericPersonAvatar({ iconSize = '64px', variant = 'light' }: GenericPersonAvatarProps) {
  return (
    <Flex
      alignItems='center'
      bg={variant === 'dark' ? 'whiteAlpha.200' : 'grey.100'}
      height='100%'
      justifyContent='center'
      width='100%'
    >
      <UserTabIcon boxSize={iconSize} color={variant === 'dark' ? 'white' : 'grey.400'} />
    </Flex>
  );
}
